'use client';

import { siteUrl, vars } from '@repo/config';
import { WebChromeProvider } from '@repo/web-chrome';
import type { JSX, ReactNode } from 'react';
import { loadLocalizedPalettePages } from './command-palette/load-localized-palette-pages';

interface IWebChromeBoundaryProps {
  children: ReactNode;
}

export function WebChromeBoundary({ children }: IWebChromeBoundaryProps): JSX.Element {
  return (
    <WebChromeProvider
      siteOrigin={siteUrl}
      catalogOrigin={vars.url.exploreUrl}
      isCatalogApp={false}
      loadLocalizedPalettePages={loadLocalizedPalettePages}
    >
      {children}
    </WebChromeProvider>
  );
}
